import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { AxiosRequestConfig } from 'axios'

export interface TeamInfoReq {
  team_id: number
}

export interface RiskInfo {
  /** 病毒影响终端数 */
  virus_affect_count: number
  /** 风险端口影响终端数 */
  port_affect_count: number
  /** 基线不合规终端数 */
  baseline_substandard_count: number
  /** 漏洞影响终端数 */
  leak_affect_count: number
  /** 勒索病毒影响终端数 */
  ransomware_affect_count: number
  /** 上周病毒影响终端数 */
  last_virus_affect_count: number
  /** 上周风险端口影响终端数 */
  last_port_affect_count: number
  /** 上周基线不合规终端数 */
  last_baseline_substandard_count: number
  /** 上周漏洞影响终端数 */
  last_leak_affect_count: number
  /** 上周勒索病毒影响终端数 */
  last_ransomware_affect_count: number
}

export interface TeamTerminalInfo {
  /** 团队ID */
  team_id: number
  /** 团队名称 */
  name: string
  /** 终端总数 */
  total: number
  /** 在线终端数 */
  online_num: number
  /** 离线终端数 */
  offline_num: number
  /** windows终端数 */
  windows_num: number
  /** linux终端数 */
  linux_num: number
  /** windows server终端数 */
  windows_server_num: number
  risk_info: RiskInfo
  /** 接入码 */
  access_code?: string
  /** ip 地址 */
  ip_addr?: string
  /** 权限列表 */
  permissions?: string[]
  /** 服务器端口 */
  server_port?: string|number
}

export interface TeamInfoRes {
  team_terminal_info?: TeamTerminalInfo
}

@Injectable()
export class TeamInfoService {
  constructor(private http: Http) {}

  getTeamInfo (data: TeamInfoReq, config: AxiosRequestConfig = {}) {
    return this.http.post<TeamInfoRes>('/cascade/team_terminal_info', data, config)
  }
}
